import React, { useRef } from "react";

import styles from "../containers/AdDetailsPage/AdDetailsPageWeb/styles/PhoneNumberButton.scss";

/**
 * Off-screen honeypot input. Real users never see or focus it, but form-autofilling
 * bots populate it. A non-empty value on click is treated as a bot signal.
 */
export const HoneypotInput = React.forwardRef((_, ref) => (
  <input
    ref={ref}
    type="text"
    name="contact_confirm"
    tabIndex={-1}
    autoComplete="off"
    aria-hidden="true"
    className={styles.honeypot}
  />
));

export const useAntiBotMeasures = () => {
  const honeypotRef = useRef(null);

  const handleClickWithAntiBotMeasure = (
    event: React.MouseEvent,
    callback: (event?: React.MouseEvent) => void
  ) => {
    // Honeypot tripped -> autofilling bot.
    if (honeypotRef.current && honeypotRef.current.value) {
      return;
    }

    // Synthetic/programmatic click (e.g. element.click()) -> bot.
    if (!(event && event.nativeEvent && event.nativeEvent.isTrusted)) {
      return;
    }

    callback(event);
  };

  return {
    honeypotRef,
    handleClickWithAntiBotMeasure
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useAntiBotMeasures.tsx